import { createHashHistory as createHistory } from "history"

export const history = createHistory({})

